import { LocalStorageProgressRepository } from './local-storage-progress-repository.js';
import type { ProgressRepository } from './progress-repository.js';

/**
 * App-wide single repository instance. Components consume the interface only;
 * the singleton glue lives here so a future cloud-sync repository can be
 * swapped in by editing this one file.
 */
let instance: ProgressRepository | undefined;

export function setProgressRepository(repo: ProgressRepository): void {
  instance = repo;
}

export function getProgressRepository(): ProgressRepository {
  if (!instance) instance = new LocalStorageProgressRepository();
  return instance;
}

/** Test-only reset. */
export function _resetProgressRepositoryForTests(): void {
  instance = undefined;
}
